/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_StudioInputs */

const en_platform_team_studio = /** @type {(inputs: Platform_Team_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const pl_platform_team_studio = /** @type {(inputs: Platform_Team_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Platform_Team_StudioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_studio = /** @type {((inputs?: Platform_Team_StudioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_StudioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_studio(inputs)
	return en_platform_team_studio(inputs)
});